var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLikeCarouselProspects(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLikeCarouselProspects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.60415314,2.48515193 C4.12771929,0.909438581 6.13092545,0.120513926 8.13684545,0.120513926 C10.1427654,0.120513926 12.1560516,0.909441774 13.6796501,2.48515193 L15.5070378,4.38085329 L17.3344578,2.49512931 C20.3816224,-0.65635806 25.3627907,-0.656287819 28.409923,2.49512931 C31.4570876,5.64654963 31.4570876,10.7079334 28.409923,13.8593569 C24.2631338,18.1480639 20.1182178,22.4415601 15.9714608,26.7301714 C15.8494034,26.8576888 15.6796158,26.9299365 15.5019978,26.9299365 C15.3243797,26.9299365 15.1545921,26.8576888 15.0325347,26.7301714 L2.60415314,13.8493635 C-0.439522152,10.6955008 -0.443011383,5.63652117 2.60415314,2.48515193 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospects-Views-Swipe-Copy-2",
    transform: "translate(-253.000000, -468.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/Flirt",
    transform: "translate(18.000000, 118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(45.000000, 350.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icLikeCarouselProspects",
    transform: "translate(190.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5384615,0.5 C13.5687188,0.5 0.5,13.5687188 0.5,29.5384615 C0.5,45.5082043 13.5687188,58.5769231 29.5384615,58.5769231 C45.5082043,58.5769231 58.5769231,45.5082043 58.5769231,29.5384615 C58.5769231,13.5687188 45.5082043,0.5 29.5384615,0.5 Z",
    id: "Stroke-1",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/light-green",
    transform: "translate(14.492308, 17.076923)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLikeCarouselProspects);
export default __webpack_public_path__ + "static/media/icLikeCarouselProspects.925e3bdaa3b2f4402e91fa27c9de8e9c.svg";
export { ForwardRef as ReactComponent };